import SSComments from './comments'

function SSCommentsLoggedIn(slideshare_object){
  SSComments.call(this,slideshare_object);
  this.setup_loggedin_actions(slideshare_object);
}

SSCommentsLoggedIn.prototype = new SSComments();

SSCommentsLoggedIn.prototype.setup_loggedin_actions = function(ss) {
  var $commentInput = ss.svComments.find('.j-post-comment-input');
  var prevlink = $('.previous-link', ss.svComments);
  var nextlink = $('.next-link', ss.svComments);
  var startlabel = null;
  var endlabel = null;
  var totallabel = null;
  var i18n = ss.utils.i18n;

  var miniDialog = function(element, yesCallback, noCallback) {
    var yesButton = element.find('#yes');
    var noButton = element.find('#no');
    var clearDialog = function(e) {
      element.hide();
      yesButton.unbind('click');
      noButton.unbind('click');
    };

    yesButton.click(function(e) {
      clearDialog();
      yesCallback(e);
    });
    noButton.click(function(e) {
      clearDialog();
      noCallback(e);
    });
    $('body').click(clearDialog);
  };

  $.extend(ss.comments, {
    create_url: ss.comments.create_url,
    destroy_url: ss.comments.destroy_url,
    delete_comment_confirmed: function(li, comment_id) {
      $.post(ss.comments.destroy_url, { id:comment_id },
        function(response_data) {
          log(response_data);
          li.fadeOut('slow', function() {
            li.remove();
          });
        });
    },
    delete_comment: function(event) {
      $('.miniDialog').hide(); //hiding any open dialogs. TODO: optimize.
      var li = $(event.target).parents('li');
      var comment_id = li[0].id.split('-')[1];
      var element = li.find('#confirmDialog-'+comment_id);
      element.find('.title').text(i18n('slideview.comments_loggedin.delete_comment.title'));
      element.show();
      var yesCallback = function(e) {
        e.preventDefault();
        ss.comments.delete_comment_confirmed(li, comment_id);
      };
      var noCallback = function(e) {e.preventDefault();};
      miniDialog(element, yesCallback, noCallback);
      $(".thumbnailGrid").trigger("adjustHeight");
      return false;
    },
    block_user: function(event) {
      $('.miniDialog').hide();
      var id = this.id,
        $li = $(event.target).parents('li'),
        comment_id = $li[0].id.split('-')[1],
        $element = $li.find('#confirmDialog-'+comment_id),
        $msgContainer = $element.siblings('#messageDialog');
      $element.find('.title').text(i18n('slideview.comments_loggedin.block_user.title'));
      $element.show();
      var callbackOnConfirm = function(e) {
        $.post("//" + document.location.host + "/block/block",
          { "blocked_id" : id },
          function(data) {
            if (data.success) {
              $(".author-"+id).find(".j-action-block").hide();
              $msgContainer.text(i18n('slideview.comments_loggedin.block_user.success'));
            } else {
              $msgContainer.text(i18n('slideview.comments_loggedin.block_user.failure'));
            }
            $msgContainer
              .addClass('warning')
              .show()
              .fadeOut(5000, function() {
                this.removeClass('warning');
              });
          }
        );
      };
      miniDialog($element, callbackOnConfirm);
      return false;
    },
    reply_to_comment: function(commentId, form) {
      var commentOf = $('#' + commentId).find('.j-username').html();
      var $commentsContainer = $commentInput.closest('.j-comment-post');
      var topOfCommentsContainer = $commentsContainer.offset().top -
        $('#main-nav').height();
      $.scrollTo(topOfCommentsContainer, 500);
      $commentInput.focus()
        .val('@' + commentOf + ' ');
    },
    post_comment: function(form) {
      log("post_comment", form);
      $commentInput.click();
      var comment = $('#commentsTemplate').clone().addClass('comment');
      comment.find('.j-action-block, .j-reply').remove();
      comment.find('.j-username').text($(form).find('.j-username').text());
      if (!ss.user.occupation){
        comment.children().remove('.j-commenter-role');
      } else {
        $('.j-commenter-role', comment).val(ss.user.occupation);
        log($('.j-commenter-role',comment).text(', ' + ss.user.occupation));
      }

      if (!ss.user.organization || ss.user.is_li_auto_created_user) {
        comment.children().remove('.j-commenter-org');
      } else {
        $('.j-commenter-org',comment).text(i18n('slideview.comments_loggedin.organization', {organization : ss.user.organization}));
      }
      $(".commentTimestamp", comment).text(i18n('slideview.comments_loggedin.timestamp'));
      $(".commentText", comment).text($commentInput.val());

      // Hide empty stat box if it exists
      if(ss.comments.total_count === 0) {
        ss.svComments.find('.empty-stat-box').remove();
      }

      comment.prependTo(ss.svCommentsul);
      ss.comments.total_count += 1;
      ss.comments.show_page(1, ss.comments.per_page, ss.comments.total_count);
      $.scrollTo(ss.svComments, 500);

      comment.add_undo("commenting", function(event, request, settings, err) {
        comment.remove();
        var responseText = request.responseText;
        if(responseText && responseText.match(/<html/i)) {
          alert(i18n('slideview.comments_loggedin.commenting.failure'));
        } else {
          alert(responseText);
        }
      });
      var key = ss.comments.get_secret_key();

      var form_data = {
        'comment[text]': $commentInput.val(),
        'followup_subscribe': 1,
        'key': key,
        'slide_order': ss.comments.slide_number,
        'slide_id': ss.presentationId,
        'version': 2
      };
      
      var that = this;
      $.post(ss.comments.create_url, form_data, function(response_data) { 
      /*If the user is a spam user, the create function returns the response data
        with spam set to true. The create function checks for the spam user: if set to
        true, it will logout the user. Since this is a ajax call, we redirect the page
        to login page here*/
          if (response_data.suspended) {
            window.location.replace('/login');
          } else {
            $(".commentText", comment).html(
              (response_data.text || "") +
                '<br />' +
                (response_data.embed || ""));
            comment[0].id = 'comment-' + response_data.id;
            $(comment[0]).find('#confirmDialog').attr('id',
                                 'confirmDialog-' + response_data.id);
            that.decorate_comment_user(comment, response_data.user);
            $('.j-action-delete', this.currently_shown).jsclick(ss.comments.delete_comment);
            $('.j-action-block', this.currently_shown).jsclick(ss.comments.block_user);
            if(document.referrer.match(/search\/slideshow/)){
              var resultNum = getUrlVar('from_search');
              if(resultNum && window._gaq){
                window._gaq.push(['_trackEvent', "searchresult", "comment_" + resultNum]);
              }
            }
          }
      }, 'json');
      $('#postComment .j-post-comment-input').val('');
    },
    sanitize_action_links: function() {
      // removing delete and block links according to permissions
      var other_comments = '#commentsList li:not(.author-' + ss.user.id + ') ';
      var my_comments = '#commentsList li.author-' + ss.user.id + ' ';
      if (! ss.user.loggedin) {
        $('#commentsList')
          .find('.j-action-delete, .j-action-block')
          .remove();
      } else {
        //delete
        if(!ss.user.su && !ss.user.owner) {
          $(other_comments + '.j-action-delete').remove();
        }
        $(my_comments + '.j-reply').remove();
        //block
        $(my_comments + '.j-action-block').remove();
        if(!ss.user.owner) {
          $(other_comments + '.j-action-block').remove();
        }
      }
    },
    retrieve_and_post_comments: function() {
      if (window.cookie('comments') !== null){
        $('#postComment .j-post-comment-input').val(window.cookie('comments'));
        //if there is any comment saved in cookie, delete cookie and post that comment
        if(ss.user.loggedin){
          ss.comments.delete_saved_comments();
          ss.comments.post_comment($('#postComment').get());
        }
      }
    }
  });

  $('.commentsWrapper').on('click', '.j-action-delete', ss.comments.delete_comment);
  $('.commentsWrapper').on('click', '.j-action-block', ss.comments.block_user);
  ss.comments.retrieve_and_post_comments();
};

window.SSCommentsLoggedIn = SSCommentsLoggedIn;
export default SSCommentsLoggedIn;
